// extracted by mini-css-extract-plugin
export default {"container":"styles_container__H0bdi","content":"styles_content__l3L89"};